export const UPDATE_HOTKEYS_STATE = '@@hot_keys/update'

export const hotKeysUpdate = (newState) => ({
	type: UPDATE_HOTKEYS_STATE,
	payload: newState
})
